import React from "react";
import { Badge, Tooltip } from "@KristianIV/common-ui";
import { explainHostWarning } from "./hostWarnings";
import { HostStatus } from "./model/scout";

/** One host warning as the device reported it, amber, with its meaning as a tooltip. */
const HostWarningBadge = ({ warning, size }: { warning: string; size?: "big" }) => (
  <Tooltip content={explainHostWarning(warning)}>
    <Badge size={size} color="amber">
      {warning}
    </Badge>
  </Tooltip>
);

export default HostWarningBadge;

/** The device's own health verdict for the page header: its warnings, or Healthy when it reports none. */
export const HostHealthBadges = ({ host, size }: { host: HostStatus; size?: "big" }) =>
  host.warnings.length === 0 ? (
    <Tooltip content="The device reports no host warnings.">
      <Badge size={size} color="green">
        Healthy
      </Badge>
    </Tooltip>
  ) : (
    <>
      {host.warnings.map((warning) => (
        <HostWarningBadge key={warning} warning={warning} size={size} />
      ))}
    </>
  );
